import React, { useState } from "react";
import {
  ActivityIndicator,
  Image,
  Modal,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { WebView } from "react-native-webview";
import { AppTheme } from "../utils/theme";
import { AppIcons } from "../assets/images";

interface Props {
  visible: boolean;
  url: string;
  title: string;
  onClose?: () => void;
}

const PrivacyWithTerms: React.FC<Props> = ({
  visible,
  url,
  title,
  onClose,
}) => {
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    if (visible) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [visible, url]);

  return (
    <Modal visible={visible} transparent animationType="slide">
      <View
        style={[
          styles.modalContainer,
          { paddingTop: Platform.OS == "ios" ? 50 : 5 },
        ]}
      >
        <View style={styles.mainView}>
          <Text style={styles.title}>{title}</Text>
          <TouchableOpacity
            style={styles.backButton}
            activeOpacity={0.7}
            onPress={onClose}
          >
            <Image
              source={AppIcons.BackIcon}
              resizeMode="contain"
              style={styles.backIcon}
            />
          </TouchableOpacity>
        </View>
        <View style={styles.container}>
          {Platform.OS === "web" ? (
            <iframe
              src={url}
              title={title}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                backgroundColor: "#ffffff",
              }}
              onLoad={() => setLoading(false)}
            />
          ) : (
            <WebView
              source={{ uri: url }}
              style={styles.webview}
              onLoadStart={() => setLoading(true)}
              onLoadEnd={() => setLoading(false)}
            />
          )}

          {loading && (
            <View style={styles.loaderContainer} pointerEvents="none">
              <ActivityIndicator size={"large"} color={AppTheme.colors.white} />
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

export default PrivacyWithTerms;

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: AppTheme.colors.linearGradient_7,
  },
  container: {
    flex: 1,
    position: "relative",
    backgroundColor: AppTheme.colors.linearGradient_7,
  },
  mainView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    marginVertical: 0,
    backgroundColor: AppTheme.colors.linearGradient_7,
  },
  title: {
    fontSize: 30,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
    textAlign: "center",
    flexShrink: 1,
    paddingVertical: 14, // Reserve space for back button
  },
  backButton: {
    position: "absolute",
    right: 0,
    top: 10, // Adjusted for better centering in header height
    width: 50,
    height: 40,
    zIndex: 10,
  },
  backIcon: {
    width: 50,
    height: 40,
  },
  webview: {
    flex: 1,
  },
  loaderContainer: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: AppTheme.colors.linearGradient_7,
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 50,
  },
});
